export const GET_PRODUCTION_PLAN_INPUTS_SUCCESS =
  'GET_PRODUCTION_PLAN_INPUTS_SUCCESS';
export const GET_PRODUCTION_PLAN_INPUTS_ERROR =
  'GET_PRODUCTION_PLAN_INPUTS_ERROR';
export const GET_PRODUCTION_PLAN_INPUTS = 'GET_PRODUCTION_PLAN_INPUTS';
export const UPDATE_MASTER_PLAN_INPUTS = 'UPDATE_MASTER_PLAN_INPUTS';
